export interface WindowCopyModalState {
    onCopy: () => void | Promise<void>;
    disabled?: boolean | Ref<boolean> | ComputedRef<boolean>;
    tooltip?: string;
}

const copyStates = ref<Map<string, WindowCopyModalState>>(new Map<string, WindowCopyModalState>());

export function useWindowCopyModal(windowId?: string) {
    return computed(() => {
        if (windowId) {
            return copyStates.value.get(windowId) || null;
        }
        return null;
    });
}

export function registerWindowCopyModal(state: WindowCopyModalState, windowId: string) {
    const newMap = new Map<string, WindowCopyModalState>(copyStates.value);
    newMap.set(windowId, state);
    copyStates.value = newMap;
}

export function unregisterWindowCopyModal(windowId: string) {
    const newMap = new Map<string, WindowCopyModalState>(copyStates.value);
    newMap.delete(windowId);
    copyStates.value = newMap;
}
